import { getEnvPath, findOutWhichEnv } from 'utils/env'
import { getHeaders, handleErrors } from './utils'

const env = findOutWhichEnv()
const BASE_PATH = `${getEnvPath(env)}/1.0/api`

function generateConversationsData(payload) {
  return fetch(`${BASE_PATH}/report/analytics`, getHeaders('POST', { ...payload, version: '2' }))
    .then((r) => r.json())
    .then(handleErrors)
}

/**
 * @param {object} payload
 * @returns string
 */
function getConversationsGuid({ wabaId, startDate, endDate, phoneNumbers, tier = 'ALL', version = '2' }) {
  return fetch(
    `${BASE_PATH}/report/analytics/export`,
    getHeaders('POST', {
      wabaId,
      startDate,
      endDate,
      phoneNumbers,
      tier,
      version,
    }),
  )
    .then((r) => r.json())
    .then(handleErrors)
}

function exportConversationsCsv(guid) {
  window.open(`${BASE_PATH}/report/analytics/export/${guid}`)
}

function getWabaList() {
  return fetch(`${BASE_PATH}/waba`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

export { generateConversationsData, exportConversationsCsv, getWabaList, getConversationsGuid }
